module.exports = __webpack_public_path__ + "static/media/mobile.8a807b47.png";